export enum MediaObjectFit {
  COVER = 'cover',
  CONTAIN = 'contain',
}
